import React from 'react';
import PropTypes from 'prop-types';
import { Button, ListGroup, ListGroupItem } from 'react-bootstrap';
import classnames from 'classnames';
import ExportList from './ExportList.jsx';
import ProjectList from './ProjectList.jsx';
import { Link } from 'react-router-dom';
import { trackEvent } from '../util/Analytics.jsx';

import { useStateValue } from '../context/state.jsx';
import { setRedirectURL } from '../context/redirectURL.js';
import { setShowAddProjectModal } from '../context/datasets.js';
import Utils from '../util/Utils.jsx';
import { clearOfflineChanges } from '../offline-features/db.js';

const FlyoutLeft = ({
	currentDataset,
	isActive,
	setIsFlyoutLeftActive,
	closeButtonRef,
	onRequestClose
}) => {
	const [{ datasets, isSuperAdmin }, dispatch] = useStateValue();

	const classes = classnames('flyoutLeft flyout', { active: isActive });

	const doLogout = redirectURL => {
		trackEvent('account', 'click', 'sign out');
		const token = localStorage.getItem('token');
		Utils.revokeServerToken(token);
		Utils.clearAuthSession(dispatch);
		clearOfflineChanges();
		dispatch(setRedirectURL(redirectURL));
	};

	return (
		<div
			id="projects-flyout"
			className={classes}
			role="dialog"
			aria-modal={isActive ? 'true' : undefined}
			aria-label="Projects"
			aria-hidden={!isActive}
			inert={!isActive ? '' : undefined}>
			<center>
				<Button
					ref={closeButtonRef}
					className="closeButton"
					aria-label="Close Projects"
					onClick={() => {
						if (typeof onRequestClose === 'function') {
							onRequestClose();
							return;
						}
						setIsFlyoutLeftActive(false);
					}}>
					<span className="glyphicon glyphicon-remove-circle leftGlyph"></span>
					Close
				</Button>
			</center>

			<div className="flyoutContent">
				<Button
					block
					className="addProject"
					onClick={() => { dispatch(setShowAddProjectModal(true)); }}>
					<span className="glyphicon glyphicon-cloud leftGlyph"></span>Add Project
				</Button>

				<ProjectList currentDataset={currentDataset} setIsFlyoutLeftActive={setIsFlyoutLeftActive} />

				{datasets && currentDataset && currentDataset in datasets && (
					datasets[currentDataset].Owned
					|| '5' in datasets[currentDataset].Permissions
					|| '8' in datasets[currentDataset].Permissions
				)
					&& <ExportList currentDataset={currentDataset} />}

				<ListGroup className="link-list-group">
					<Link to="/setup/">
						<ListGroupItem>
							<span className="glyphicon glyphicon-cog leftGlyph"></span>Setup
						</ListGroupItem>
					</Link>
					{isSuperAdmin && (
						<Link to="/superadmin/" onClick={() => setIsFlyoutLeftActive(false)}>
							<ListGroupItem>
								<span className="glyphicon glyphicon-lock leftGlyph"></span>Super Admin
							</ListGroupItem>
						</Link>
					)}
					<Link to="/about/">
						<ListGroupItem>
							<span className="glyphicon glyphicon-info-sign leftGlyph"></span>About
						</ListGroupItem>
					</Link>
					<a href="https://get.sitewalkerapp.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
						<ListGroupItem>
							<span className="glyphicon glyphicon-list-alt leftGlyph"></span>Terms of Service
						</ListGroupItem>
					</a>
				</ListGroup>

				<Button
					block
					bsStyle="danger"
					onClick={() => {
						doLogout(null);
					}}>
					<span className="glyphicon glyphicon-off leftGlyph"></span>
					Sign Out
				</Button>
			</div>
		</div>
	);
};

FlyoutLeft.propTypes = {
	currentDataset: PropTypes.string,
	isActive: PropTypes.bool,
	setIsFlyoutLeftActive: PropTypes.func,
	closeButtonRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.any })
	]),
	onRequestClose: PropTypes.func
};

export default FlyoutLeft;